import { gql } from '@apollo/client';

export const SCORING_RESULT_ITEM_FIELDS = gql`
  fragment ScoringResultItemFields on ScoringResultItem {
    _id
    batchId
    jobOfferId
    talentId
    favoriteId
    mode
    score
    explainer
    status
    errorMessage
    retryCount
    createdAt
    updatedAt
    talentInfo {
      fullName
      email
      photo
    }
    jobOfferInfo {
      title
      jobNumber
      logo
    }
  }
`;

export const TRIGGER_SCORING = gql`
  mutation TriggerScoring($input: TriggerScoringInput!) {
    triggerScoring(input: $input) {
      batchId
      totalQueued
      validationWarnings {
        talentId
        favoriteId
        jobOfferId
        reason
      }
    }
  }
`;

export const RETRY_SCORING_BATCH = gql`
  mutation RetryScoringBatch($batchId: String!) {
    retryScoringBatch(batchId: $batchId) {
      batchId
      totalQueued
      validationWarnings {
        talentId
        favoriteId
        jobOfferId
        reason
      }
    }
  }
`;

export const GET_SCORING_BATCH = gql`
  query GetScoringBatch($batchId: String!) {
    getScoringBatch(batchId: $batchId) {
      batchId
      total
      pending
      inProgress
      done
      error
      results {
        ...ScoringResultItemFields
      }
    }
  }
  ${SCORING_RESULT_ITEM_FIELDS}
`;

export const GET_TALENT_JOB_OFFER_SCORE = gql`
  query GetTalentJobOfferScore($talentId: ID, $favoriteId: ID, $jobOfferId: ID!) {
    getTalentJobOfferScore(talentId: $talentId, favoriteId: $favoriteId, jobOfferId: $jobOfferId) {
      ...ScoringResultItemFields
    }
  }
  ${SCORING_RESULT_ITEM_FIELDS}
`;

export const LIST_SCORING_BATCHES = gql`
  query ListScoringBatches($page: Int, $limit: Int) {
    listScoringBatches(page: $page, limit: $limit) {
      totalDocs
      totalPages
      page
      docs {
        batchId
        mode
        total
        pending
        inProgress
        done
        error
        jobOfferId
        triggeredById
        createdAt
      }
    }
  }
`;
